import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';
import { WebAccessControlSchedulerBaseDataProvider } from '../dataProvider/WebAccessControlSchedulerBaseDataProvider';

export class WebAccessControlSchedulerDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, WebAccessControlSchedulerBaseDataProvider);
  }
}
